export function Footer() {
  return (
    <footer className="site-footer">
      <img src="/logo-horizontal.png" alt="reviewbub" />
      <p>Book PR, author marketing, media outreach, podcast visibility, book club campaigns, and premium reporting.</p>
    </footer>
  );
}
